export default "__VITE_ASSET__B4bb2p$j__"